import React from 'react';

const BunkerIcon = (props) => {
  return (
    <img
      alt="Bunkier"
      src="/static/images/icons/place_types/bunker.svg"
      {...props}
    />
  );
};

export default BunkerIcon;
